import { mdiAccountCircle, mdiApps, mdiArrowDownThin, mdiArrowLeft, mdiArrowLeftThin, mdiArrowULeftTop, mdiArrowUpThin, mdiCheck, 
    mdiChevronLeft, mdiChevronRight, mdiCog, mdiCommentQuote, mdiDelete, mdiDotsVertical, mdiDownload, mdiFilePdfBox, mdiForum, mdiHelpCircle, 
    mdiHome, mdiLogout, mdiMagnify, mdiOpenInNew, mdiPencil, mdiPrinter, mdiSync, mdiTranslate, mdiVideo, mdiWifi, mdiWifiAlert } from '@mdi/js'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import { aliases,mdi } from 'vuetify/iconsets/mdi-svg'

import aliasesAndDefaults from '../objects/_aliasesAndDefaults'
import { crvThemeDark,crvThemeLight } from '../objects/_CrvTheme.js'


const aliasesDefaultsThemes = {
    ...aliasesAndDefaults,
    theme: {
    defaultTheme: 'crvThemeLight',
    themes: {
        crvThemeLight,
        crvThemeDark,
    },
    },
}

const vuetifyDefaultConfig = {
    components,
    directives,
    ...aliasesDefaultsThemes,
    icons: {
    defaultSet: 'mdi',
    sets: { mdi },
    aliases: {
        ...aliases,
        arrowLeftThin: mdiArrowLeftThin,
        arrowLeft: mdiArrowLeft,
        accountCircle: mdiAccountCircle,
        apps: mdiApps,
        check: mdiCheck,
        chevronLeft: mdiChevronLeft,
        chevronRight: mdiChevronRight,
        cog: mdiCog,
        commentQuote: mdiCommentQuote,
        delete: mdiDelete,
        dotsVertical: mdiDotsVertical,
        download: mdiDownload,
        edit: mdiPencil,
        forum: mdiForum,
        help: mdiHelpCircle,
        home: mdiHome,
        logout: mdiLogout,
        magnify: mdiMagnify,
        openInNew: mdiOpenInNew,
        pdf: mdiFilePdfBox,
        printer: mdiPrinter,
        sortAsc: mdiArrowUpThin, // Overwrite vuetify default
        sortDesc: mdiArrowDownThin, // Overwrite vuetify default
        sync: mdiSync,
        translate: mdiTranslate,
        undo: mdiArrowULeftTop,
        video: mdiVideo,
        wifi: mdiWifi,
        wifiAlert: mdiWifiAlert,
    }
    },
}

export {
    aliasesAndDefaults,
    aliasesDefaultsThemes,
    crvThemeDark,
    crvThemeLight,
    vuetifyDefaultConfig
}